import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorShippingHeaderApproval = () => {
  const { t } = useTranslation()
  const shippingHeaderApproval = useCallback(
    (body) => {
      const payload = {
        ...body,
      }

      ApiService.jsonRequest('/transaction-shipping-header/approval', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.order_status_has_been_update`),
            timer: 2000,
            reload: true,
          })
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response?.messages}`),
            timer: 2000,
            reload: false,
          })
        }
      })
    },
    [t],
  )

  return { shippingHeaderApproval }
}

export default InteractorShippingHeaderApproval
